import { useSyncExternalStore } from 'react'

import {
  getStatusBannerHost,
  subscribeStatusBannerHost,
} from '../utils/statusBannerHost'

/**
 * The node this banner should portal into, or `null` before the viewport has mounted.
 *
 * `useSyncExternalStore` rather than `useState` + an effect: the host is external mutable state,
 * and the viewport can register before a banner's first render. Reading through the store means
 * a banner mounting later sees the host immediately instead of rendering `null` for one frame.
 */
export function useStatusBannerHost(): HTMLElement | null {
  return useSyncExternalStore(
    subscribeStatusBannerHost,
    getStatusBannerHost,
    () => null,
  )
}
